import React from "react";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import CssBaseline from "@mui/material/CssBaseline";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import "../../assets/fonts/fontsRoboto.module.scss";
import "../../assets/styles/tokens.module.scss";
import createTheme from "./index";
export const getDocNonce = () => {
    var _a, _b;
    return ((_b = (_a = document.querySelector('meta[name="CSP-NONCE"]')) === null || _a === void 0 ? void 0 : _a.getAttribute("content")) !== null && _b !== void 0 ? _b : undefined);
};
const emotionInsertionPoint = document.createElement("meta");
emotionInsertionPoint.setAttribute("name", "emotion-insertion-point");
emotionInsertionPoint.setAttribute("content", "");
document.head.appendChild(emotionInsertionPoint);
const wrapInLayer = (layerName) => (node) => {
    if (node.root)
        return;
    const child = { ...node, parent: node, root: node };
    Object.assign(node, {
        children: [child],
        length: 6,
        parent: null,
        props: [layerName],
        return: "",
        root: null,
        type: "@layer",
        value: `@layer ${layerName}`,
    });
};
const emotionCache = createCache({
    key: "emotion",
    nonce: getDocNonce(),
    insertionPoint: emotionInsertionPoint,
    stylisPlugins: [wrapInLayer("mui")],
});
const Theme = ({ children }) => {
    const theme = createTheme();
    return (React.createElement(StyledEngineProvider, { injectFirst: true },
        React.createElement(CacheProvider, { value: emotionCache },
            React.createElement(ThemeProvider, { theme: theme, defaultMode: "system" },
                React.createElement(CssBaseline, null),
                children))));
};
export default Theme;
//# sourceMappingURL=Theme.js.map